import React from "react";
import { useSelector, useDispatch } from "react-redux";
import AuthModal from "./AuthModal";
import UnifiedOtpValidate from "../otpvalidation/UnifiedOtpValidate";
import RegisterUserSelection from "./RegisterUserSelection";
import CustomerRegistrationForm from "../userregistration/CustomerRegistrationForm"; // Import karo
import { closeAllModals } from "../../redux/authSlice";

const AuthManager = () => {
  const dispatch = useDispatch();
  const {
    isAuthModalOpen,
    isOtpModalOpen,
    isSelectionOpen,
    isRegistrationOpen,
    authMode,
    flow,
    identity,
  } = useSelector((state) => state.auth);

  const handleClose = () => dispatch(closeAllModals());

  return (
    <>
      {isAuthModalOpen && (
        <AuthModal
          isOpen={isAuthModalOpen}
          mode={authMode}
          onClose={handleClose}
        />
      )}
      {isOtpModalOpen && (
        <UnifiedOtpValidate
          isOpen={isOtpModalOpen}
          flow={flow}
          identity={identity}
          onClose={handleClose}
        />
      )}
      {isSelectionOpen && (
        <RegisterUserSelection isOpen={isSelectionOpen} onClose={handleClose} />
      )}
      {isRegistrationOpen && (
        <CustomerRegistrationForm
          isOpen={isRegistrationOpen}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default AuthManager;
